import React, { FunctionComponent, useCallback } from 'react';
import { Presentation } from './presentation';
import { PreferredOccupationItem } from '../../../types/personShow';

type Props = {
  mainTitle: string;
  penIconImg: string;
  motivation: string;
  preferredLocations: string[];
  preferenceConditions: string[];
  preferredOccupations: PreferredOccupationItem[];
  handleOpenModal: (target: string, title: string) => void;
  isShow: boolean;
};

export const Component: FunctionComponent<Props> = ({
  mainTitle,
  penIconImg,
  motivation,
  preferredLocations,
  preferredOccupations,
  preferenceConditions,
  handleOpenModal,
  isShow,
}) => {
  const handleClick = useCallback((target: string, title: string) => {
    handleOpenModal(target, title);
  }, [handleOpenModal]);

  return (
    <Presentation
      mainTitle={mainTitle}
      penIconImg={penIconImg}
      motivation={motivation}
      preferredLocations={preferredLocations}
      preferredOccupations={preferredOccupations}
      preferenceConditions={preferenceConditions}
      isShow={isShow}
      handleClick={handleClick}
    />
  );
};
